// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"cd4188e2","769":"b47bb380","856":"0d7b74b7"}[chunkId] + ".chunk.js";
};